module.exports = __webpack_public_path__ + "static/media/FloorDivot_Before.212e398c.jpg";